import { useState, useEffect } from 'react';
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { User } from "lucide-react";

interface ProfileAvatarProps {
	src: string | null | undefined;
	alt: string;
	fallbackIcon?: React.ReactNode;
	className?: string;
	participantId?: string;
	conversationId?: string;
	onImageError?: (participantId: string, conversationId?: string) => void;
}

export const ProfileAvatar: React.FC<ProfileAvatarProps> = ({
	src,
	alt,
	fallbackIcon,
	className = "h-8 w-8",
	participantId,
	conversationId,
	onImageError
}) => {
	const [imageError, setImageError] = useState(false);
	const [currentSrc, setCurrentSrc] = useState(src);

	// Reset error state when src changes
	useEffect(() => {
		setImageError(false);
		setCurrentSrc(src);
	}, [src]);

	const handleImageError = () => {
		if (!imageError && participantId && onImageError) {
			setImageError(true);
			onImageError(participantId, conversationId);
		}
	};

	// Use a direct img element with error handling
	if (currentSrc && !imageError) {
		return (
			<Avatar className={className}>
				<img
					src={currentSrc}
					alt={alt}
					className="h-full w-full rounded-sm object-cover"
					onError={handleImageError}
				/>
			</Avatar>
		);
	}

	// Show fallback when no src or error occurred
	return (
		<Avatar className={className}>
			<AvatarFallback>
				{fallbackIcon || <User className="h-4 w-4" />}
			</AvatarFallback>
		</Avatar>
	);
};
